import { SuccessButton } from 'components/button';
import { hideSharePopupAction } from 'components/share/share.actions';
import { COLOR } from 'constants/colors';
import { ENDPOINTS } from 'constants/endpoints';
import React from 'react';
import { useMediaQuery } from 'react-responsive';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import styled from 'styled-components';
import { getDefaultHeaders, post } from '__utils/ajax-wrapper';
import { getEncryptedUserId, getName, getURLwithoutPro, isProUser,filterSpaceSlashFromString } from '__utils/common-utils';
import {  useDispatch } from 'react-redux';
import { CommonStyledComponentProps } from '__utils/type';
import resolveURLParams from '__utils/url-params-resolver';
import moment from 'moment';
import ShareButton from 'components/share-button';
import useFlashToggler from 'hooks/use-flash-toggler';
import { getEventName, Mixpanel } from '__utils/mixpanel';

const NfoCard = styled.div<CommonStyledComponentProps>`
    padding: ${(props) => props.isMobile ? '16px' : '24px 30px 24px'};
    border-bottom: 0.5px solid  #D2D5D6;
    background: white;
    &:last-child{
        border: none;
        margin-bottom: ${(props) => props.isMobile ? '' : '37px'};
    }
    p{
        margin-bottom:12px;
        font-size: ${(props) => props.isMobile ? '' : '18px'};
        font-weight: ${(props) => props.isMobile ? '' : '500'};
    }
    .nfoDates{
        display: grid;
        grid-template-columns: repeat(2,1fr);
        width: ${(props) => props.isMobile ? '' : '575px'};
        p{
            margin:0;
            font-weight: 400;
            font-size: ${(props) => props.isMobile ? '12px' : '16px'};
            line-height: ${(props) => props.isMobile ? '22px' : '28px'};
            span{
                color: ${COLOR.GREY3};
            }
        }
    } 
    .nfoCTaSection {
        display: flex;
        justify-content: flex-start;
        margin-top: ${(props) => props.isMobile ? '15px;' : ''};
        position: ${(props) => props.isMobile ? '' : 'absolute'};
        right: ${(props) => props.isMobile ? '' : '0'};
        top: ${(props) => props.isMobile ? '' : '0'};
        .shareDiv,button{
            width:118px;
        }
        .shareDiv{
            margin-right: ${(props) => props.isMobile ? '' : '10px'};
        }
    }
`

interface nfosCardProps {
    key: number;
    nfoCardItem?: any;
    className?: any;
}

const NfosCard: React.FC<nfosCardProps> = ({ nfoCardItem }: nfosCardProps) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const dispatch = useDispatch();
    const flash = useFlashToggler();
    
    const getShareNfoMsg = (nfo: any) => {
        return window.encodeURIComponent(
            `Hi ${getName() ? getName() : ''},\n\nYou can proceed with investing in *${nfo?.schemeName}* by clicking on the link below. You will be redirected to the Turtlemint Money website to place your NFO order. \n\nThe closing date for this NFO is *${moment(Number(nfo.nfoClousureDate)).format('DD MMMM YYYY')}*, make sure you place your order before that.\n\n${getShareURL(nfo)}\n\nTurtlemint Money`);
    }

    const getShareURL = (nfo: any) => {
        return getURLwithoutPro(`/mutual-fund-detail/${filterSpaceSlashFromString(nfo.schemeName)}?schemeId=${nfo.encryptedSchemeId}&nfoType=${nfo.nfoCategory}`)
    }

    //@purpose: share via email/sms
    const shareNFODetails = (...args:any[]) => {
        const shareType = args[1] === 'email' ? 'email' : 'mobile';
        if(args[2]){
            const nfoShareElement = args[2];
            const nfoBodyObject = {
                type: shareType,
                value: args[0],
                customer: getName() ? getName() : '',
                closeDate: nfoShareElement.nfoClousureDate,
                schemeId: nfoShareElement?.encryptedSchemeId,
                shareUrl: window.encodeURIComponent(getShareURL(nfoShareElement).replace(/&amp;/g, "&")),
            };
            post(resolveURLParams(ENDPOINTS.POST_NFO_SHARE, {}, { ucc: getEncryptedUserId() }), nfoBodyObject, getDefaultHeaders(), true)
                .subscribe((response: AjaxResponse | AjaxError) => {
                    if (response?.response?.meta?.message === 'success') {
                        flash.success('NFO link shared successfully!!!');
                        dispatch(hideSharePopupAction());
                    }
    
                }, (error: AjaxError) => {
                    flash.error("Failed to share NFO link. Please try again later.");
                    dispatch(hideSharePopupAction());
                });
        }
        
    }

    const goToNfokDetails = (nfo: any) => {
        window.location.href = window.location.origin + `/mutual-fund-detail/${nfo.schemeName}?schemeId=${nfo.encryptedSchemeId}&nfoType=${nfo.nfoCategory}`;
        Mixpanel.track(getEventName("view", "clicked", "nfos"),{
            schemeName: nfo.schemeName,
        });
    }
    
    return (
        <div className='mb24'>
            {nfoCardItem.map((element: any, index: number) => (
                <NfoCard isMobile={isMobile} key={index} className={element.minimumLumpsumAmount|| element.minimumSipAmount ? 'show' : 'hide'}>
                    <div className={(element.isChecked || element.isChecked === undefined)? 'show posR': 'hide'}>
                    <p>{element.schemeName}</p>
                    <div className='nfoDates'>
                        <p><span>Launch - </span> {moment(Number(element.nfoOpenDate)).format('DD MMMM YYYY')}</p>
                        <p><span>Closing - </span> {moment(Number(element.nfoClousureDate)).format('DD MMMM YYYY')}</p>
                        <p><span>Min Amount  -  </span> ₹{element.minimumLumpsumAmount ||element.minimumSipAmount}</p>
                    </div>
                    <div className="nfoCTaSection">
                        { isProUser() ? (
                        <div className='shareDiv'>
                            <ShareButton shareConfig=
                                {{
                                    message: getShareNfoMsg(element),
                                    shareUrl: getShareURL(element),
                                    onEmailOrSMSShare: shareNFODetails,
                                    shareItemDetails: element,
                                    shareType: 'shareNFODetails',
                                    mixpanelData: { eventName: 'nfoShare', source: 'nfos' }
                                }}
                            />
                        </div>
                        ) : null }

                        <div><SuccessButton onClick={() => goToNfokDetails(element)}>View Details</SuccessButton></div>
                    </div>
                    </div>
                </NfoCard>
            ))
            }
        </div >
    );
}

export default NfosCard;